"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializePublicTypebot = exports.convertTypebotToPublic = exports.deserializePublicTypebot = void 0;
const __1 = require("..");
const __2 = require("../..");
const deserializePublicTypebot = (typebot) => {
    var _a, _b;
    return ({
        version: 2,
        createdDate: typebot.created_date
            ? new Date(typebot.created_date)
            : undefined,
        modifiedDate: typebot.modified_date
            ? new Date(typebot.modified_date)
            : undefined,
        customDomains: (_a = typebot.custom_domains) !== null && _a !== void 0 ? _a : [],
        theme: (0, __1.deserializeTheme)(typebot.theme),
        id: typebot.id,
        language: typebot.language,
        name: (_b = typebot.name) !== null && _b !== void 0 ? _b : "",
        settings: (0, __1.deserializeSettings)(typebot.settings),
        steps: (0, __1.deserializeSteps)(typebot.steps),
        variables: (0, __1.deserializeVariables)(typebot.variables),
        connectors: deserializeConnectors(typebot.public_connectors),
        startConditions: (0, __1.deserializeStartConditions)(typebot.start_conditions),
        metaData: (0, __1.deserializeMetaData)(typebot.meta_data),
        webhooks: deserializeWebhooks(typebot.public_webhooks),
        credentials: (0, __1.deserializeCredentials)(typebot.public_credentials),
        httpRequests: (0, __1.deserializeHttpRequests)(typebot.public_http_requests),
        publishId: typebot.publish_id,
        typebotId: typebot.typebot_id,
    });
};
exports.deserializePublicTypebot = deserializePublicTypebot;
const convertTypebotToPublic = (typebot, publishId) => ({
    version: 2,
    createdDate: typebot.createdDate,
    customDomains: typebot.customDomains,
    language: typebot.language,
    modifiedDate: typebot.modifiedDate,
    name: typebot.name,
    settings: typebot.settings,
    theme: typebot.theme,
    typebotId: typebot.id,
    variables: typebot.variables,
    metaData: typebot.metaData,
    connectors: convertConnectorsToPublic(typebot.connectors),
    startConditions: typebot.startConditions,
    steps: typebot.steps,
    webhooks: convertWebhooksToPublic(typebot.webhooks),
    credentials: convertCredentialsToPublic(typebot.credentials),
    httpRequests: convertHttpRequestsToPublic(typebot.httpRequests),
    publishId,
});
exports.convertTypebotToPublic = convertTypebotToPublic;
const serializePublicTypebot = (typebot) => ({
    id: typebot.id,
    created_date: typebot.createdDate,
    modified_date: typebot.modifiedDate,
    public_connectors: typebot.connectors,
    custom_domains: typebot.customDomains,
    language: typebot.language,
    meta_data: typebot.metaData,
    name: typebot.name,
    settings: typebot.settings,
    start_conditions: typebot.startConditions,
    steps: typebot.steps,
    theme: typebot.theme,
    variables: typebot.variables,
    public_webhooks: typebot.webhooks,
    public_credentials: typebot.credentials,
    public_http_requests: typebot.httpRequests,
    publish_id: typebot.publishId,
    typebot_id: typebot.typebotId,
});
exports.serializePublicTypebot = serializePublicTypebot;
const deserializeConnectors = (connectors) => connectors;
const deserializeWebhooks = (webhooks) => webhooks;
const convertConnectorsToPublic = (connectors) => connectors
    ? connectors.map((connector) => {
        if (connector.type === __2.ConnectorType.GOOGLE_SHEETS)
            return Object.assign(Object.assign({}, connector), { params: {
                    stepIndex: connector.params.stepIndex,
                } });
        return connector;
    })
    : undefined;
const convertWebhooksToPublic = (webhooks) => webhooks
    ? webhooks.map((w) => ({
        stepIndex: w.stepIndex,
    }))
    : undefined;
const convertCredentialsToPublic = (credentials) => credentials
    ? credentials.map((c) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { privateKey } = c, paymentInfo = __rest(c, ["privateKey"]);
        return paymentInfo;
    })
    : undefined;
const convertHttpRequestsToPublic = (httpRequests) => httpRequests ? httpRequests.map((h) => ({ id: h.id })) : undefined;
//# sourceMappingURL=publicTypebots.js.map